import React from 'react'
import { PatientsTableHead } from '../PatientsTableHead'
import { PatientsTableRow } from '../PatientsTableRow'
import { IPatient } from '../../types'

import {
  Table,
  TableHead,
  TableBody
} from './styles'

interface PatientsTableProps {
  patients: IPatient[]
  loading: boolean
  activeTab: number
  onClickPatient: (patient: IPatient) => void
}

export const PatientsTable = ({
  patients,
  loading,
  activeTab,
  onClickPatient
}: PatientsTableProps): JSX.Element => {

  return (
    <Table
      isLoading={loading}
      isEmpty={!patients.length}
    >
      <TableHead isEmpty={!patients.length}>
        <PatientsTableHead activeTab={activeTab} />
      </TableHead>

      <TableBody>
        {patients.map((patient) => (
          <PatientsTableRow 
            key={patient.email} 
            patientData={patient}
            onClickPatient={onClickPatient}
          />
        ))}
      </TableBody>
    </Table>
  )
}